import { ServiceMaker } from "./index";

export const unloadPackages = (data?: any) =>
  ServiceMaker("package/unloading", "POST", data);

export const notAtReceived = (data?: any) =>
  ServiceMaker("package/notYetReceived", "PATCH", data);
